<template>
  <div class="footer">
    <div class="container">
      <Row justify="space-between" class="footer-top">
        <div class="position">
          <!-- <img :src="gImg.index.logo" /> -->
          <img
            :src="language == 'cn' ? gImg.index.logo : gImg.index.logoEN"
            @click="index()"
            style="width: 100%; height: 100%; cursor:pointer;"
          />
        </div>
        <Col :lg="17" :md="0" :sm="0" :xs="0">
          <div class="space-between box">
            <div
              class="link font-16"
              v-for="(item, index) in list"
              :key="index"
              @click="jump(index)"
            >
              <div class="title">{{ $t(item.title) }}</div>
              <div class="children font-16">
                <div
                  class="children-item"
                  v-for="(items, indexs) in $t(item.children)"
                  :key="indexs"
                >
                  {{ items }}
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col :lg="6" :md="0" :sm="0" :xs="0" class="item">
          <div class="address font-16">
            <div class="title">{{ $t(contact) }}</div>
            <div class="children">
              <div
                class="children-item font-14 flex"
                v-for="(item, index) in $t(address)"
                :key="index"
              >
                <div class="tips">{{ item.title }}:</div>
                <div class="">
                  {{ item.data }}
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Row justify="space-between" class="footer-bottom">
        <Col :lg="10" :md="12" :sm="12" :xs="24" class="left">
          <!-- <img
            :src="language == 'cn' ? gImg.index.logo : gImg.index.logoEN"
            @click="index()"
            style="width: 723px; height: 143px"
          /> -->
          <div class="flex">
            <div style="cursor:pointer;" class="text" @click="hrefUrl(140,'隐私政策')">{{ $t(footerText.textone) }}</div>
            <div style="cursor:pointer;" class="text" @click="hrefUrl(141,'使用约定')">{{ $t(footerText.texttwo) }}</div>
            <div style="cursor:pointer;" class="text" @click="hrefUrl(142,'免责声明')">{{ $t(footerText.textthree) }}</div>
          </div>
        </Col>
        <Col :lg="14" :md="24" :sm="24" :xs="24" class="right">
          <div class="flex flexEnd">
            <div class="record">沪ICP备2021035915号</div>
            <div class="">{{ $t(copyright.listone) }}</div>
            <div class="">{{ $t(copyright.listtow) }}</div>
          </div>
          <!-- <div class="space-between">
            <div class="">{{ $t(copyright.listthree) }}</div>
          </div> -->
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import VueI18n from "vue-i18n";
export default {
  name: "footers",
  // 定义属性
  data() {
    return {
      list: [
        {
          title: "footer.titleone",
          children: "footer.childrenone",
        },
        {
          title: "footer.titletow",
          children: "footer.childrentow",
        },
        {
          title: "footer.titlethree",
          children: "footer.childrenthree",
        },
        {
          title: "footer.titlefour",
          children: "footer.childrenfour",
        },

        {
          title: "footer.titleseven",
          children: "footer.childrenseven",
        },
        {
          title: "footer.titlefive",
          children: "footer.childrenfive",
        },
        {
          title: "footer.titlesix",
          children: "footer.childresix",
        },
        {
          title: "footer.titleeight",
          children: "footer.childreneight",
        },
        {
          title: "footer.titlenine",
          children: "footer.childrennine",
        },
      ],
      contact: "contact",
      address: "address",
      copyright: {
        listone: "copyright.listone",
        listtow: "copyright.listtow",
        listthree: "copyright.listthree",
      },
      footerText: {
        textone: "footerText.textone",
        texttwo: "footerText.texttwo",
        textthree: "footerText.textthree",
      },
      language: "",
    };
  },
  created() {
    this.language = localStorage.getItem("language");
  },
  methods: {
    hrefUrl(value,label){
       this.$router.push({name:'privacyPolicy',query:{id:value,name:label}});
    },
    index() {
      this.$router.push("/index");
    },
    jump(e) {
      switch (e) {
        case 0:
          this.$router.push("/bylaws");
          break;
        case 1:
          this.$router.push("/dynamics");
          break;
        case 2:
          this.$router.push("/research");
          break;
        case 3:
          this.$router.push("/journal");
          break;
        case 4:
          // this.$router.push("/country");
          window.open("http://www.acnworldwide.com/country");
          break;
        case 5:
          this.$router.push("/naHsien");
          break;
        case 6:
          this.$router.push("/support");
          break;
        case 7:
          this.$router.push("/affairs");
          break;
        case 8:
          this.$router.push("/hotspot/aindex");
          break;
      }
    },
  },
};
</script>
<style scoped type="text/css" lang="scss">
@import "../css/footer.css";
@import "../scss/global.scss";

.children {
  margin-top: 20px;
}
.flexEnd {
  justify-content: flex-end;
}
.footer {
  z-index: 55;
  background-color: #2e3a61;
  color: $headerText;
  position: relative;
  // z-index: 1;
  .record {
    margin-right: 50px;
  }
  .footer-top {
    position: relative;
    padding-left: 10px;
    border-bottom: 0.5px solid #707890;
    padding-bottom: 50px;
    z-index: 999;
    .position {
      width: 500px;
      // height: 103px;

      // style="width: 723px; height: 143px"
      overflow: hidden;
      position: absolute;
      bottom: 20px;
      right: 20px;
      // background-color: red;

      img {
        width: 100%;
        height: 100%;
      }

      // display: none;
    }
    .link {
      width: 80px;
      cursor: pointer;
      height: fit-content;
      .title {
        cursor: pointer;
        width: 80px;
        line-height: 30px;
        border-bottom: 0.5px solid $headerText;
      }

      .children-item {
        line-height: 24px;
      }
    }

    .address {
      .title {
        width: 80px;
        line-height: 30px;
        border-bottom: 0.5px solid $headerText;
        margin-bottom: 10px;
      }

      .children-item {
        line-height: 24px;

        .tips {
          margin-right: 5px;
        }
      }
    }
  }

  .footer-bottom {
    padding: 10px 0 85px 0;
    align-items: center;
    .text {
      padding-right: 30px;
    }
    .left {
      text-align: left;
      margin-bottom: 10px;

      img {
        width: 715px;
        height: 157px;
        object-fit: contain;
        margin: -20px;
      }
    }
  }
}

@media (max-width: 990px) {
  .flexEnd{
    display: block;
  }
  .position {
    display: none;
  }

  .footer {
    .footer-top {
      display: none;
    }

    .footer-bottom {
      .left {
        img {
          width: 100%;
          height: 50px;
          object-fit: contain;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue